import { getPrefixFromEnvServer } from "@app/utils/get-prefix-from-env.server";

export const ROUTE_PREFIX = getPrefixFromEnvServer();

export const addRoutePrefix = (path: string): string => {
	return `${ROUTE_PREFIX}${path}`;
};